export enum LesebestaetigungAnfordernVariables {
  'documentToReadFilename' = 'documentToReadFilename',
  'documentToRead' = 'documentToRead',
  _bokuFlow_workflowResultProtocolJSON = '_bokuFlow_workflowResultProtocolJSON',
  'processInstanceId' = 'processInstanceId',
  'confirmationSummaryPdf' = 'confirmationSummaryPdf'
}

export const LesebestaetigungAnfordernVariablesSearchable = [];
